import {IMapper} from "./i-mapper";
import {
  EApplicationSettingsFieldType,
  IApp,
  IApplicationSettingsDropdownField,
  IApplicationSettingsInstalledAppsField,
  IApplicationSettingsNumberField,
  IApplicationSettingsTextField,
  IApplicationSettingsToggleField,
  ILauncherSettings,
  TLauncherSettingsFieldType
} from "@zaeper/angular-application-store-lib";
import {TFieldElement} from "@zaeper/angular-dashboard-view-lib";
import {FormGroup} from "@angular/forms";
import {ApplicationSettingsTextFieldMapper} from "./settings-input-field/application-settings-text-field.mapper";
import {ApplicationSettingsNumberFieldMapper} from "./settings-input-field/application-settings-number-field.mapper";
import {ApplicationSettingsToggleFieldMapper} from "./settings-input-field/application-settings-toggle-field.mapper";
import {ApplicationSettingsDropdownFieldMapper} from "./settings-input-field/application-settings-dropdown-field.mapper";
import {
  ApplicationSettingsInstalledAppsFieldMapper
} from "./settings-input-field/application-settings-installed-apps-field.mapper";

export class LauncherSettingsInputFieldMapper implements Partial<IMapper<ILauncherSettings, TFieldElement[]>> {
  constructor(private readonly _apps: IApp[]) {
  }

  from(launcherSettings: ILauncherSettings): TFieldElement[] {
    const formGroup: FormGroup = new FormGroup({});

    return launcherSettings.fields.reduce((acc: TFieldElement[], curr: TLauncherSettingsFieldType): TFieldElement[] => {
      switch (curr.type) {
        case EApplicationSettingsFieldType.TEXT:
          acc.push(new ApplicationSettingsTextFieldMapper(formGroup).from(curr as IApplicationSettingsTextField));
          break;
        case EApplicationSettingsFieldType.NUMBER:
          acc.push(new ApplicationSettingsNumberFieldMapper(formGroup).from(curr as IApplicationSettingsNumberField));
          break;
        case EApplicationSettingsFieldType.TOGGLE:
          acc.push(new ApplicationSettingsToggleFieldMapper(formGroup).from(curr as IApplicationSettingsToggleField));
          break;
        case EApplicationSettingsFieldType.DROPDOWN:
          acc.push(new ApplicationSettingsDropdownFieldMapper(formGroup).from(curr as IApplicationSettingsDropdownField));
          break;
        case EApplicationSettingsFieldType.INSTALLED_APPS:
          acc.push(new ApplicationSettingsInstalledAppsFieldMapper(this._apps, formGroup).from(curr as IApplicationSettingsInstalledAppsField));
          break;
        case EApplicationSettingsFieldType.MULTI_SELECT:
        case EApplicationSettingsFieldType.SLIDER:
        case EApplicationSettingsFieldType.RANGE_SLIDER:
        case EApplicationSettingsFieldType.COLOR_PICKER:
        case EApplicationSettingsFieldType.FILE:
        case EApplicationSettingsFieldType.REPLICATION:
        case EApplicationSettingsFieldType.GROUP:
          // TODO Phase 3: add view-lib InputMultiSelect, InputSlider, InputRangeSlider, InputColorPicker, InputFile,
          // InputReplication / InputGroup renderers + matching per-type mappers.
          console.warn('Unsupported launcher settings field type (pending Phase 3 view-lib components)', curr.type);
          break;
        default: {
          const _exhaustive: never = curr;
          console.warn('Unknown launcher settings field type', _exhaustive);
        }
      }
      return acc;
    }, []);
  }
}
